// ═══════════════════════════════════════════════════════════════
// Audit Log — lightweight change tracking
// Writes to the activityLog table on key operations
// ═══════════════════════════════════════════════════════════════

import { TABLES, FIELDS, createRecord } from './api-switch';
import { useAuthStore } from '../store/authStore';

const F = FIELDS.activityLog;

export async function logActivity(
  module: string,
  action: string,
  targetType: string,
  targetId: string,
  details: string,
) {
  try {
    const { user, activeIncident, token } = useAuthStore.getState();
    await createRecord(TABLES.activityLog, [
      [F.incidentId, activeIncident?.id ? String(activeIncident.id) : ''],
      [F.module, module],
      [F.action, action],
      [F.actorName, user?.fullName || ''],
      [F.actorEmail, user?.email || ''],
      [F.targetType, targetType],
      [F.targetId, targetId],
      [F.details, details.substring(0, 500)],
    ], token ?? undefined);
  } catch {
    // Non-blocking — audit failures should never break the app
  }
}
